// Shared "Events" category accent (Unreal convention: node color encodes
// category, never re-themed — same reasoning as cameraTheme.js's
// CAMERA_ACCENT). Lives inside src/components/nodes/ deliberately — that
// directory is the node-body/pin/wire functional-color exemption in
// tests/unit/paletteEnforcement.test.mjs, so this constant gives
// EventGraph.jsx's palette entries (beginPlay, onConstruct) ONE source
// instead of each hardcoding a second copy of the same literal.
export const EVENTS_ACCENT = '#ff5050'
